import { ALL_AOLS, AOL_DISPLAY_NAMES, PRACTICE_AREAS, PRACTICE_AREAS_DISPLAY_NAMES, PRACTISING_AOL_OTHER } from 'constants/aol/aol'
import { NO_ACCESS_MESSAGE } from './aolTooltipText'
import { AOLType } from 'types/AOL'

interface AolOption {
  name: string
  urlFragment: string
  disabled: boolean
  disabledReason: string | undefined
}

interface PractisingAolOption {
  label: string
  selected: boolean
  value: string
}

// Generate dropdown options with optional access checking
export const getAolOptions = (hasAccess: (aol: string) => boolean, noAccessMessage: string = NO_ACCESS_MESSAGE): AolOption[] => {
  return ALL_AOLS.map(aol => {
    const isDisabled = !hasAccess(aol)
    return {
      name: AOL_DISPLAY_NAMES[aol as AOLType],
      urlFragment: aol,
      disabled: isDisabled,
      disabledReason: isDisabled ? noAccessMessage : undefined
    }
  })
}

const hasAolAccessByRole = (aol: string, accessRoles: string[]): boolean => {
  return accessRoles.some(role => role.startsWith(`${aol}_`))
}

// Generate AOL options with general role-based access control
export const getAolOptionsByRole = (accessRoles: string[]): AolOption[] => {
  return getAolOptions(
    (aol) => hasAolAccessByRole(aol, accessRoles)
  )
}

export function getPractisingAolDropdownOptions (selected: string | null): PractisingAolOption[] {
  const isOtherSelected = selected !== null && selected !== '' && !PRACTICE_AREAS.includes(selected)
  return [
    ...PRACTICE_AREAS.map(aol => ({
      label: PRACTICE_AREAS_DISPLAY_NAMES[aol] !== '' ? PRACTICE_AREAS_DISPLAY_NAMES[aol] : aol,
      selected: selected === aol,
      value: aol
    })),
    {
      label: 'Other',
      selected: isOtherSelected,
      value: PRACTISING_AOL_OTHER
    }
  ]
}
